import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin } from 'lucide-react';
import Container from './Container';
import Logo from './Logo';
import { mainNavigation, utilityNavigation } from '../config/navigation';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-900 text-white">
      <Container>
        <div className="py-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 mb-8">
            {/* Organization Info */}
            <div className="md:col-span-2">
              <div className="mb-6">
                <Logo size="md" className="text-white" />
              </div>
              <p className="text-gray-300 mb-4 leading-relaxed max-w-md text-sm">
                Building a national safety rail for Nigeria so every person can reach help fast and every response is accountable.
              </p>
              <div className="space-y-3">
                <div className="flex items-center space-x-3 text-gray-300">
                  <Mail className="h-4 w-4 flex-shrink-0" />
                  <a href="mailto:info@openhopeinitiative.com" className="hover:text-white transition-colors">
                    info@openhopeinitiative.com
                  </a>
                </div>
                <div className="flex items-center space-x-3 text-gray-300">
                  <Phone className="h-4 w-4 flex-shrink-0" />
                  <a href="tel:+2349155556074" className="hover:text-white transition-colors">
                    +234 915 555 6074
                  </a>
                </div>
                <div className="flex items-center space-x-3 text-gray-300">
                  <MapPin className="h-4 w-4 flex-shrink-0" />
                  <span>Shop 309, Amah Plaza, Kado</span>
                </div>
              </div>
            </div>
            
            {/* Navigation Links */}
            <div>
              <h4 className="text-lg font-semibold mb-4">Navigation</h4>
              <ul className="space-y-3">
                {mainNavigation.slice(0, 6).map((item) => (
                  <li key={item.path}>
                    <Link 
                      to={item.path} 
                      className="text-gray-300 hover:text-white transition-colors duration-120"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
            
            {/* Utility Links */}
            <div>
              <h4 className="text-lg font-semibold mb-4">Resources</h4>
              <ul className="space-y-3">
                {utilityNavigation.map((item) => (
                  <li key={item.path}>
                    <Link 
                      to={item.path} 
                      className="text-gray-300 hover:text-white transition-colors duration-120"
                    >
                      {item.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
        <div className="border-t border-gray-800 py-6">
          <div className="text-center text-sm text-gray-400">
            <p>&copy; {new Date().getFullYear()} Open Hope Initiative Nigeria. All rights reserved.</p>
          </div>
        </div>
      </Container>
    </footer>
  );
};

export default Footer;